import { F } from "@/components/sheets/SheetFrame";

export const Table = ({ x, y, cols, rows, title, rh = 4.6, testid }) => {
  const fs = Math.max(1.6, 2.2 * rh / 4.6), ty = rh * 0.7;
  let cx = x;
  const xs = cols.map((c) => { const v = cx; cx += c.w; return v; });
  const W = cx - x;
  return (
    <g data-testid={testid}>
      <text x={x} y={y - 1.5} fontSize={2.8} fontFamily={F} fontWeight="bold" fill="#000">{title}</text>
      <rect x={x} y={y} width={W} height={rh} fill="#0E7490" />
      {cols.map((c, i) => <text key={c.h} x={xs[i] + 1} y={y + ty} fontSize={fs} fill="#fff" fontFamily={F}>{c.h}</text>)}
      {rows.map((r, j) => (
        <g key={j}>
          <rect x={x} y={y + rh * (j + 1)} width={W} height={rh} fill={j % 2 ? "#F1F5F9" : "#fff"} stroke="#CBD5E1" strokeWidth={0.15} />
          {r.map((v, i) => <text key={i} x={xs[i] + 1} y={y + rh * (j + 1) + ty} fontSize={fs} fill="#000" fontFamily={F}>{String(v ?? "").slice(0, Math.floor(cols[i].w / (fs / 1.9)))}</text>)}
        </g>
      ))}
    </g>
  );
};
